<template>
    <v-container>
        <v-row>
            <v-col cols="3" v-for="(inventory, index) in products" :key="inventory.id" class="padding-top-0">
                <v-card>
                    <v-card-title>
                        <span class="item-name-product">{{ inventory.product.name }}</span>
                    </v-card-title>
                    <hr :class="'line-title ' + selectLineColor(index)">
                    <v-card-subtitle>
                        <span>
                            <v-icon size="18" class="mr-1" :color="selectColor(index)">fas fa-tags</v-icon>
                        </span>
                        <span class="item-stock-product">
                            Stock: {{ inventory.stock}}
                        </span>                        
                    </v-card-subtitle>
                    <v-card-actions>
                        <div style="width: 100%;">
                            <v-btn outlined class="float-right" dark color="#424242" 
                                @click="handleViewKardex(inventory)"
                                v-if="verifyPermission('ver_movimientos_storehouse')">
                                Movimientos
                            </v-btn>
                        </div>                        
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Kardex ref="kardex"></Kardex>
    </v-container>    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import Kardex from './Kardex'

export default {
    name: 'ListProducts',
    components: {
        Kardex
    },
    data() {
        return {
            count_color_line: 0,
            count_color: 0,
            color_selected: '#E53935',
            colors_line: [
                'line-red', 
                'line-green', 
                'line-blue', 
                'line-puple', 
                'line-lime',
                'line-orange',
                'line-yellow',
                'line-brow'
            ],
            colors: [
                '#E53935',
                '#43A047',
                '#1E88E5',
                '#5E35B1',
                '#C0CA33',
                '#F4511E',
                '#FFB300',
                '#6D4C41'
            ]
        }
    },
    computed: {
        ...mapState('storehouses', [
            'storehouseSelected',
            'products',
        ]),
    },
    methods: {
        ...mapActions('storehouses', [
            'runSetProductSelected',
            'getKardexByInventory'
        ]),
        handleViewKardex(product){
            this.getKardexByInventory(product.id)
            this.$refs.kardex.showForm('Movimientos', product.product.name)
        },
        selectLineColor(index){
            let indexColor = index
            if (index >= 8) {
                indexColor = index % 8
            }

            let color = this.colors_line[indexColor]

            return color
        },
        selectColor(index) {
            let indexColor = index
            if (index >= 8) {
                indexColor = index % 8
            }

            let color = this.colors[indexColor]

            return color
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    }
}
</script>

<style>
.item-name-product{
    font-size: 18px;
}

.line-title{
    height: 1px !important;
    border: 1px solid;
}

.line-red {
    background-color:#E53935 !important;
    border-color:#E53935;
}

.line-green {
    background-color:#43A047 !important;
    border-color:#43A047;
}

.line-blue {
    background-color:#1E88E5 !important;
    border-color:#1E88E5;
}

.line-puple {
    background-color:#5E35B1 !important;
    border-color:#5E35B1;
}

.line-lime {
    background-color:#C0CA33 !important;
    border-color:#C0CA33;
}

.line-orange {
    background-color:#F4511E !important;
    border-color:#F4511E;
}

.line-yellow {
    background-color:#FFB300 !important;
    border-color:#FFB300;
}

.line-brow {
    background-color:#6D4C41 !important;
    border-color:#6D4C41;
}

.item-stock-product{
    font-weight: bold;
    font-size: 14px;
}
</style>